import { IProvenancesStore } from '../index'
import { IAcceptProvenance } from '../../../actions/provenances/addProvenance'

export default function(
  state: IProvenancesStore,
  action: IAcceptProvenance,
): IProvenancesStore {
  return {
    ...state,
    provenances: [...state.provenances, ...action.provenance],
  }
}
